import React from "react";
import { Column } from "./dataTable.common";

export interface BodyFieldProps<T> {
  datarow: any;
  column: Column<T>;
}

export class BodyField extends React.PureComponent<BodyFieldProps<any>> {
  render() {
    const { column, datarow } = this.props;

    return (
      <td
        className={
          (column.props.classNameSelector &&
            column.props.classNameSelector(this.props.datarow)) ||
          column.props.className
        }
        style={column.props.style}>
        {column.getCell(datarow)}
      </td>
    );
  }
}
